import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  ClickAwayListener,
  Grow,
  InputAdornment,
  MenuItem,
  MenuList,
  OutlinedInput,
  Pagination,
  Paper,
  Popper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import PageHeader from 'app/components/PageHeader';
import TemplateCard from './TemplateCard';
import { btnStatusPayment } from '../PaymentOrdersPage/PaymentOrdersPage.sx';
import useTemplatePage from './useTemplatePage';
import { inputStyle, outlinedInput, customStyles } from './TemplatesPage.sx';
import SearchIcon from 'app/components/Icons/SearchIcon';
import CloseIcon from 'app/components/Icons/CloseIcon';
import CustomSelect from 'app/components/CustomSelect';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';
import SaleIcon from 'app/components/Icons/SaleIcon';
import Select, { components } from 'react-select';
import { lastOperationsNone, pagination, searchNone } from 'app/components/LastOperations/LastOperations.sx';
import { grayText } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { menuItems } from 'app/components/PageHeader/PageHeader.sx';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomSnackbar from 'app/components/CustomSnackbar';
import { TemplateTypeOption } from 'app/components/SelectOption/SelectOption';
import SelectValueContainer from 'app/components/SelectValueContainer';
import { useChangeNameTemplate, useDeleteTemplate } from 'app/utils/services/templateService';
import logger from 'app/utils/logger';

const options = [
  {
    value: 'Öz hesablarım arasında',
    label: 'Öz hesablarım arasında',
    icon: <CoinsSwapIcon />,
    templateType: 'payment_acc2acc',
  },
  { value: 'Bankdaxili', label: 'Bankdaxili', icon: <BankIcon />, templateType: 'payment_interbank' },
  { value: 'Ölkədaxili', label: 'Ölkədaxili', icon: <ManatIcon />, templateType: 'payment_local_transfer' },
  { value: 'Ölkəxarici', label: 'Ölkəxarici', icon: <GlobusIcon />, templateType: 'payment_foreign_transfer' },
  {
    value: 'Konvertasiya',
    label: 'Konvertasiya',
    icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} />,
    templateType: 'payment_conversion',
  },
  { value: 'Ədv ödənişi', label: 'Ədv ödənişi', icon: <CoinsStackedIconSelect />, templateType: 'payment_edv' },
  { value: 'Büdcə ödənişi', label: 'Büdcə ödənişi', icon: <WalletIconSelect />, templateType: 'payment_budget' },
];

export const IconOption = (props: any) => (
  <components.Option {...props}>
    {props.data.icon}
    {props.data.label}
  </components.Option>
);

const TemplatesPage = () => {
  const {
    btnId,
    setBtnId,
    searchInputValue,
    setSearchInputValue,
    handleSearchInputValue,
    control,
    register,
    dataGetTemplates,
    isLoadingGetTemplates,
    open,
    anchorRef,
    navigate,
    handleClose,
    handleToggle,
    handleListKeyDown,
    mediumScreens,
    // handleChangeSelectedType,
    selectedType,
    dataFilterTemplate,
    isLoadingFilterTemplate,
    optionsFilter,
    onChange,
    getValue,
    isOptionSelected,
    handleChangePage,
    page,
  } = useTemplatePage();

  const location = useLocation();
  const state = location.state;
  const pathUrl = location.pathname.substring(4);
  const [openSnackbar, setOpenSnackbar] = useState(state);
  const [openSnackbarName, setOpenSnackbarName] = useState(state);

  const { isLoadingDeleteTemplate, dataDeleteTemplate, deleteTemplateMutation } = useDeleteTemplate(
    pathUrl.endsWith('edit-template')
  );
  const { isLoadingChangeNameTemplate, changeNameTemplateMutation, dataChangeNameTemplate } = useChangeNameTemplate();

  useEffect(() => {
    if (state !== null && state !== undefined) {
      setOpenSnackbar(state.deleted);
    }
  }, [state]);

  useEffect(() => {
    if (dataDeleteTemplate?.result === 'accepted') {
      setOpenSnackbar(true);
    }
  }, [dataDeleteTemplate]);

  useEffect(() => {
    if (dataChangeNameTemplate?.result === 'accepted') {
      setOpenSnackbarName(true);
    }
  }, [dataChangeNameTemplate]);

  if (isLoadingGetTemplates) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <PageHeader pageName={'Şablonlar'} showBtnBox={true} createTemplate={dataGetTemplates?.templates.length !== 0} />
      {dataGetTemplates?.templates.length !== 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
          {/*<Box sx={{ display: 'flex', gap: '8px' }}>*/}
          {/*{filterBtns.map((item, index) => (*/}
          {/*  <Button*/}
          {/*    key={item.id}*/}
          {/*    color={'tertiary'}*/}
          {/*    sx={*/}
          {/*      btnId === item.id*/}
          {/*        ? { ...btnStatusPayment, background: 'white', boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)' }*/}
          {/*        : btnStatusPayment*/}
          {/*    }*/}
          {/*    onClick={() => setBtnId(item.id)}*/}
          {/*  >*/}
          {/*    {item.title}*/}
          {/*  </Button>*/}
          {/*))}*/}
          {/*</Box>*/}

          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
              '@media screen and (max-width: 630px)': { flexDirection: 'column', alignItems: 'flex-start' },
            }}
          >
            <OutlinedInput
              sx={outlinedInput}
              inputProps={{
                style: inputStyle,
              }}
              // inputRef={searchRef}
              // value={searchInputValue}
              placeholder={'Şablonun adı və ya məbləğ'}
              onInput={(e: any) => handleSearchInputValue(e)}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              // endAdornment={
              //   searchInputValue.length > 0 && (
              //     <InputAdornment position="end" onClick={() => setSearchInputValue('')}>
              //       <CloseIcon />
              //     </InputAdornment>
              //   )
              // }
            />
            <Select
              // options={getOptions()
              options={optionsFilter}
              isMulti={true}
              components={{
                IndicatorSeparator: () => null,
                MultiValueRemove: () => null,
                // ValueContainer: SelectValueContainer,
                Option: TemplateTypeOption,
                ValueContainer: SelectValueContainer,
              }}
              styles={customStyles}
              isSearchable={false}
              // menuIsOpen={isOpenMenu}
              isClearable={false}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder={'Köçürmənin növü'}
              // value={getValue()}
              value={getValue()}
              onChange={onChange}
              isOptionSelected={isOptionSelected}
            />
          </Box>
        </Box>
      )}
      {dataGetTemplates?.templates.length === 0 ? (
        <Box
          sx={{
            ...lastOperationsNone,
            height: 'calc(100vh - 238px)',
          }}
        >
          <Box sx={searchNone}>
            <SearchIcon />
          </Box>
          <Typography sx={{ fontSize: '16px', color: grayText }}>
            Sizin hal-hazırda əks olunacaq şablonunuz yoxdur
          </Typography>
          <Button
            size={mediumScreens ? 'medium' : 'large'}
            ref={anchorRef}
            // onClick={handleMoveTransfer}
            sx={{ mt: '12px' }}
            onClick={handleToggle}
          >
            Şablon yarat
          </Button>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            sx={{
              // zIndex: 1000,
              height: '25vh',
              minHeight: '25vh',
              maxHeight: '25vh',
              overflowY: 'scroll',
            }}
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: 'right top',
                }}
              >
                <Paper sx={{ boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)' }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                    >
                      {options.map((item) => (
                        <MenuItem
                          key={item.value}
                          onClick={(e) => {
                            handleClose(e);
                            navigate(`/az/templates-page/new-template?type=${item.templateType}`, {
                              state: { subtitle: item.value },
                            });
                          }}
                          sx={menuItems}
                        >
                          {item.icon}
                          {item.label}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      ) : (
        <Box
          sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '16px', marginTop: '27px' }}
        >
          {isLoadingFilterTemplate ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : dataFilterTemplate === undefined ? (
            dataGetTemplates?.templates.map((item: any) => (
              <TemplateCard
                key={item.id}
                id={item.id}
                type={
                  item.trn_type === 'payment_acc2acc'
                    ? 'Öz hesablarım arasında'
                    : item.trn_type === 'payment_interbank'
                    ? 'Bankdaxili'
                    : item.trn_type === 'payment_local_transfer'
                    ? 'Ölkədaxili'
                    : item.trn_type === 'payment_foreign_transfer'
                    ? 'Xarici valyutada'
                    : item.trn_type === 'payment_conversion'
                    ? 'Konvertasiya'
                    : item.trn_type === 'payment_edv'
                    ? 'Ədv ödənişi'
                    : item.trn_type === 'payment_budget' && 'Büdcə ödənişi'
                }
                data={item.data}
                changeNameTemplateMutation={changeNameTemplateMutation}
                deleteTemplateMutation={deleteTemplateMutation}
                dataChangeName={dataChangeNameTemplate}
              />
            ))
          ) : (
            dataFilterTemplate?.templates.map((item: any) => (
              <TemplateCard
                key={item.id}
                id={item.id}
                type={
                  item.trn_type === 'payment_acc2acc'
                    ? 'Öz hesablarım arasında'
                    : item.trn_type === 'payment_interbank'
                    ? 'Bankdaxili'
                    : item.trn_type === 'payment_local_transfer'
                    ? 'Ölkədaxili'
                    : item.trn_type === 'payment_foreign_transfer'
                    ? 'Xarici valyutada'
                    : item.trn_type === 'payment_conversion'
                    ? 'Konvertasiya'
                    : item.trn_type === 'payment_edv'
                    ? 'Ədv ödənişi'
                    : item.trn_type === 'payment_budget' && 'Büdcə ödənişi'
                }
                data={item.data}
                changeNameTemplateMutation={changeNameTemplateMutation}
                deleteTemplateMutation={deleteTemplateMutation}
                dataChangeName={dataChangeNameTemplate}
              />
            ))
          )}
        </Box>
      )}
      {openSnackbar && (
        <CustomSnackbar
          open={openSnackbar}
          setOpen={setOpenSnackbar}
          hideDuration={5000}
          type={'success'}
          text={'Şablon uğurla silindi'}
        />
      )}
      {openSnackbarName && (
        <CustomSnackbar
          open={openSnackbarName}
          setOpen={setOpenSnackbarName}
          hideDuration={5000}
          type={'success'}
          text={'Şablon adı uğurla dəyişdirildi'}
        />
      )}
      {dataGetTemplates?.templates.length > 0 && (
        <Pagination
          page={page}
          onChange={handleChangePage}
          sx={pagination}
          count={Math.ceil(dataGetTemplates?.counters.templates_count / 30)}
          variant="outlined"
          shape="rounded"
        />
      )}
    </>
  );
};

export default TemplatesPage;
